<template>
  <div>
    <div class="bar">
      <div class="w">
        <img
          class="btns"
          @click="to_xaizai()"
          src="../../assets/img/pagess/gdd116/底部按钮01.gif"
          alt=""
        />
      </div>
    </div>
    <div class="h1">
      <div class="aaa">
        <p>投资有风险，入市需谨慎</p>
      </div>
      <div class="w">
        <div class="li-1">
          <div class="l">
            <img src="../../assets/img/pagess/gdd116/h1-1.png" alt="" />
          </div>
          <div class="r">更精確！更好用！更实战！</div>
        </div>
        <div class="li-2">
          <img src="../../assets/img/pagess/gdd116/h1-2.png" alt="" />
          <img src="../../assets/img/pagess/gdd116/h1-3.png" alt="" />
        </div>
        <div class="li-3 btn">
          <img
            @click="to_xaizai()"
            src="../../assets/img/pagess/gdd116/h1-4.png"
            alt=""
          />
        </div>
        <div class="li-4">
          <div class="lis1"><span>></span> 不占内存</div>
          <div class="lis2">
            <img src="../../assets/img/pagess/gdd116/h1-9.png" alt="" />
          </div>
          <div class="lis1"><span>></span> 功能全面</div>
          <div class="lis2">
            <img src="../../assets/img/pagess/gdd116/h1-9.png" alt="" />
          </div>
          <div class="lis1"><span>></span> 专注龙头</div>
          <div class="lis2">
            <img src="../../assets/img/pagess/gdd116/h1-9.png" alt="" />
          </div>
        </div>
        <div class="li-5">
          <img src="../../assets/img/pagess/gdd116/h1-5.png" alt="" />
          <img src="../../assets/img/pagess/gdd116/h1-6.png" alt="" />
          <img src="../../assets/img/pagess/gdd116/h1-7.png" alt="" />
          <img src="../../assets/img/pagess/gdd116/h1-8.png" alt="" />
        </div>
      </div>
    </div>
    <div class="h2">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd116/h2-4.png" alt="" />
        </div>
        <div class="li-2">行情&数据&结果一站式</div>
        <div class="li-3">
          <div class="left">
            <div class="text">
              天相投资顾问有限公司，创立于2001 年。近20年历史的专业投资咨询机构
              （证监基金字【2004】114号），其 全资子公司北京天相财富管理顾问有
              限公司，具有证券投资顾问资格专业 投资咨询机构
            </div>
          </div>
          <div class="right">
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd116/h2-1.png" alt="" />
              <span>闪电行情</span>
            </div>
            <div class="lis2">秒级刷新高速行情，实时掌握当前买卖大数据；</div>
            <div class="lis3">
              <img src="../../assets/img/pagess/gdd116/h2-2.png" alt="" />
            </div>
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd116/h2-1.png" alt="" />
              <span>高效看盘</span>
            </div>
            <div class="lis2">
              聚焦基本面、技术面、资金面、消息面四位一体更全面；
            </div>
            <div class="lis3">
              <img src="../../assets/img/pagess/gdd116/h2-2.png" alt="" />
            </div>
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd116/h2-1.png" alt="" />
              <span>精准选股</span>
            </div>
            <div class="lis2">
              六维共振法多维度捕捉龙头机会，辅助选股，策略结果化。
            </div>
            <div class="lis4 btn">
              <img
                @click="to_xaizai()"
                src="../../assets/img/pagess/gdd116/h2-5.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd116/h3-1.png" alt="" />
        </div>
        <div class="li-2">
          选不中好股，盲目跟盘，盲目杀跌，策略直指炒股操作难题，轻松掌握，简易操作。
        </div>
        <div class="li-3">
          <div class="main">
            <div class="lis1">
              <div class="text1">一招判断龙头情绪</div>
              <div class="text2">
                抓龙头，先看短线龙头情绪周期，股多多10秒快速解决难题：擒龙环境60分钟K线翻红，开启新龙头周期
              </div>
            </div>
            <div class="lis2">
              <div class="text1">一键锁定核心热点</div>
              <div class="text2">
                秒速捕获异动板块，涵盖板块热度与涨停力度，一眼看出热点扩散效应与炒作持续性。实现智能盯盘数据可视化
              </div>
            </div>
            <div class="lis3">
              <div class="text1">六维共振优选好股</div>
              <div class="text2">
                龙头的四大形态——启动、主升、二波趋势全把握！提前行情变化适配性选股决策体系，结合六维共振方法买在低位
                逃顶高位，直击想要的好股票!
              </div>
            </div>
          </div>
        </div>
        <div class="li-4" style="margin-top: 20px">
          <img
            class="btn"
            @click="to_xaizai()"
            src="../../assets/img/pagess/gdd116/h3-3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <div class="li-1">构建体系&nbsp;&nbsp;&nbsp;&nbsp;有效寻龙</div>
        <div class="li-2">专业 / 实战 / 智能 / 好用</div>
        <div class="li-3">
          <div class="left">
            <div class="text1">告别“三不懂”</div>
            <div class="text2">不懂市场情绪，不懂龙头选股，不懂市场游</div>
            <div class="text2">资，寻龙版在手，助力你轻松擒龙!</div>
          </div>
          <div class="right">
            <div class="text1">构建自己的龙头体系</div>
            <div class="text2">通过“认知市场+优选策略+专业指导+教学培训”来</div>
            <div class="text2">构建—整套属于你自己的投资龙头体系！</div>
          </div>
        </div>
        <div class="li-4">
          <img
            class="btn"
            @click="to_xaizai()"
            src="../../assets/img/pagess/gdd116/h4-2.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="h5">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd116/h2-4.png" alt="" />
        </div>
        <div class="li-2">
          <div class="left">
            <div class="lis1 liss1">
              <div class="text1">
                深度数据估算，全面跟踪主力资金实时与阶段流向
              </div>
            </div>
            <div class="lis1 liss2">
              <div class="texts1 text1">
                3大决策系统：擒龙环境、龙头雷达、五大
              </div>
              <div class="text1">股池捕捉全线龙头机会的共振策略</div>
            </div>
            <div class="lis1 liss3">
              <div class="text1 texts1">5套技术指标，5套资金指标</div>
              <div class="text1">8大盯盘利器，多渠道监测市场异动</div>
            </div>
            <div class="lis1 liss4">
              <div class="text1 texts1">买前测测，投资风格的自我诊断</div>
              <div class="text1">专家看点，实战体系，点啥学啥</div>
            </div>
          </div>
          <div class="right">
            <img src="../../assets/img/pagess/gdd116/h5-1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="h7">
      <div class="w">
        <div class="text1">—— 投资有风险 入市需谨慎 ——</div>
        <div class="text2">
          从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询
        </div>
        <div class="text2">
          公司：北京天相财富管理顾问有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
            href="https://beian.miit.gov.cn/#/Integrated/index"
          >
            京ICP备16068579号-1</a
          >
        </div>
        <div class="text2">业务资格许可证编号：91110102MA001GJE1N</div>

        <div class="text2">
          <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          股多多软件版本号：v1.3.1.1288 更新时间：2022年2月
        </div>

        <p
          class="text2 qwer"
          style="text-decoration: underline; cursor: pointer; margin: 5px 0"
        >
          <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          <span @click="open_yinsi()" style="margin-right: 10px"
            >隐私保护政策</span
          >
          <span @click="open_fuwuxieyi()">软件服务协议</span>
        </p>
        <div class="text2">开发者名称:北京天相财富管理顾问有限公司</div>
        <!-- 010-58299331 -->
      </div>
    </div>
    <div class="box"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      res: false
    };
  },
  mounted() {
    this.clientIp();
  },
  methods: {
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD2002.exe");
      // window.open("https://cdn.juniubang.com/apk/GDD2002.exe");
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          url: window.location.href,
          qhclickid: this.$route.query.sourceid,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => {  window.open(res.data.message);});
    },

    clientIp() {
      this.$http.post("/client_ip", { url: window.location.href }).then(res => {
        window.localStorage.setItem("_number", res.data);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.h7 {
  width: 100%;

  background-color: #e2f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #989192;
    line-height: 21px;
    .text1 {
      padding-top: 24px;
      margin-bottom: 20px;
    }
    .qwer span:hover {
      color: #fff;
    }
  }
}
.box {
  width: 100%;
  height: 140px;
}
.bar {
  z-index: 999;
  width: 100%;
  height: 140px;
  background: url(../../assets/img/pagess/gdd116/bar.png) no-repeat center;
  position: fixed;
  bottom: 0;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
}
.h1 {
  width: 100%;
  height: 935px;
  background: url(../../assets/img/pagess/gdd116/h1.png) no-repeat center;
  .aaa {
    width: 200px;
    margin: 0 auto;
    position: relative;
    p {
      position: absolute;
      right: -700px;
      top: 80px;
      font-size: 16px;
      font-weight: 400;
      color: #928f8f;
    }
  }
  .w {
    width: 1202px;
    margin: 0 auto;
    height: 100%;
    .li-1 {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 28px;
    }
    .li-2 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 61px;
    }
    .li-3 {
      margin-bottom: 58px;
    }

    .li-4 {
      width: 381px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .lis1 {
        font-size: 39px;
        font-family: Microsoft YaHei;
        line-height: 22px;
        span {
          color: #bd0600;
          font-weight: bold;
        }
      }
      .lis2 {
        margin: 20px 0;
      }
    }
    .li-5 {
      margin-top: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
.h2 {
  width: 100%;
  height: 895px;
  background: url(../../assets/img/pagess/gdd116/h2.png) no-repeat center;
  .w {
    width: 1202px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 80px;
    }
    .li-2 {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #df042c;
      line-height: 20px;
      margin-top: 34px;
      margin-bottom: 67px;
    }
    .li-3 {
      width: 100%;
      display: flex;
      align-items: center;
      .left {
        width: 356px;
        height: 525px;
        background: url(../../assets/img/pagess/gdd116/h2-3.png) no-repeat
          center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text {
          padding-top: 332px;
          width: 258px;
          height: 151px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #31010a;
          line-height: 27px;
        }
      }
      .right {
        margin-left: 63px;

        display: flex;
        flex-direction: column;
        .lis1 {
          display: flex;
          align-items: center;
          padding-left: 38px;
          margin-bottom: 25px;
          font-size: 37px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #cd0529;
          line-height: 22px;
          img {
            margin-right: 28px;
          }
        }
        .lis2 {
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #31010a;
          padding-left: 95px;
          white-space: nowrap;
        }
        .lis3 {
          margin-bottom: 33px;
        }
        .lis4 {
          padding-left: 141px;
          margin-top: 69px;
        }
      }
    }
  }
}
.h3 {
  width: 100%;
  height: 1373px;

  background: url(../../assets/img/pagess/gdd116/h3.png) no-repeat center;
  .w {
    width: 1202px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 80px;
      margin-bottom: 34px;
    }
    .li-2 {
      margin-bottom: 30px;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #df042c;
      line-height: 46px;
    }

    .li-3 {
      width: 1200px;
      height: 956px;
      background: url(../../assets/img/pagess/gdd116/h3-2.png) no-repeat center;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .main {
        padding-right: 34px;
        padding-top: 85px;
      }

      .text1 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #cc0000;
        margin-bottom: 29px;
      }
      .text2 {
        width: 449px;
        height: 96px;
        font-size: 25px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 35px;
        margin-bottom: 100px;
      }
    }
    .li-4 {
      margin-top: 20 px;
    }
  }
}
.h4 {
  width: 100%;
  height: 802px;
  background: url(../../assets/img/pagess/gdd116/h4.png) no-repeat center;
  .w {
    width: 1205px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      font-size: 45px;
      font-weight: 600;
      padding-top: 55px;
      margin-bottom: 15px;
    }
    .li-2 {
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #df042c;
      line-height: 46px;
      margin-bottom: 35px;
    }
    .li-3 {
      width: 1205px;
      height: 415px;
      background: url(../../assets/img/pagess/gdd116/h4-1.png);
      display: flex;
      .left {
        padding-top: 149px;
        padding-left: 85px;
      }
      .right {
        padding-top: 93px;
        margin-left: 250px;
      }
      .text1 {
        margin-bottom: 36px;
        font-size: 53px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ae0220;
      }
      .text2 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3c3c3c;
        line-height: 38px;
      }
    }
    .li-4 {
      margin-top: 31px;
    }
  }
}
.h5 {
  width: 100%;
  height: 890px;
  background: url(../../assets/img/pagess/gdd116/h5.png) no-repeat center;
  overflow: hidden;
  .w {
    width: 1202px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 58px;
      margin-bottom: 11px;
    }
    .li-2 {
      width: 1202px;
      height: 781px;
      position: relative;
      // background-color: red;x
      .left {
        padding-top: 83px;
        .lis1 {
          width: 424px;
          height: 120px;
          margin-bottom: 20px;
        }
        .liss1 {
          background: url(../../assets/img/pagess/gdd116/h5-3.png) no-repeat
            center;
          .text1 {
            padding-top: 60px;
          }
        }
        .liss2 {
          background: url(../../assets/img/pagess/gdd116/h5-4.png) no-repeat
            center;
          .texts1 {
            padding-top: 45px;
          }
        }
        .liss3 {
          background: url(../../assets/img/pagess/gdd116/h5-5.png) no-repeat
            center;
          .texts1 {
            padding-top: 45px;
          }
        }
        .liss4 {
          background: url(../../assets/img/pagess/gdd116/h5-6.png) no-repeat
            center;
          .texts1 {
            padding-top: 45px;
          }
        }
        .text1 {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          line-height: 28px;
          padding-left: 34px;
        }
      }
      .right {
        position: absolute;
        top: 0;
        left: 226px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd134.vue